export default __webpack_public_path__ + "static/media/netcomet3.e9870b60.png";